module.exports = __webpack_public_path__ + "static/img/16.d350423.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/ITInfrastructure/16.png
// module id = SrQm
// module chunks = 1